import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _pick from "lodash/pick";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { MigrationResult } from './migration-result';
export const migrateV0ToV1 = data => {
  const baseData = _pick(data, ['title', 'xp', 'course_id', 'chapter_id', 'assignment', 'hint']);
  return new MigrationResult('v1', _objectSpread(_objectSpread({}, baseData), {}, {
    question: {
      feedback: data.feedbacks,
      flavor: 'PureMultipleChoice',
      possible_answers: data.possible_answers
    }
  }));
};
export const migrateV1ToV2 = data => {
  // For the existing flavor nothing changes from V1 to V2.
  return new MigrationResult('v2', data);
};
const unreachable = t => {
  throw new Error("this was supposed to be unreachable ".concat(t));
};
export const migrateV2ToV3 = data => {
  const pureMultipleChoiceData = _pick(data, ['title', 'xp', 'course_id', 'chapter_id', 'assignment', 'hint', 'question.feedback', 'question.flavor', 'question.possible_answers']);
  const {
    question
  } = data;
  switch (question.flavor) {
    case 'PureMultipleChoice':
      // Remove the question.question field and any other added fields.
      return new MigrationResult('v3', pureMultipleChoiceData);
    case 'PureMultipleAnswers':
      return new MigrationResult('v3', data);
    default:
      unreachable(question);
  }
  return new MigrationResult('v3', data);
};
export const migrations = {
  v0: migrateV0ToV1,
  v1: migrateV1ToV2,
  v2: migrateV2ToV3
};
export default migrations;